import { MAIN_PHONE_NUMBER } from '@constants/index'
import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { parse } from 'cookie'
import { PagesPath, pagesTitles } from 'data/pages-titles'
import type { GetServerSideProps } from 'next'
import { DEFAULT_CITY } from 'regions/list'
import { getAppliedCityFromCookies, getDetectedCityFromCookies } from 'regions/utils'

import { Contacts } from '../screens/contacts'

const ContactsPage: NextPageFC<Empty, PageLayoutOwnProps> = (props) => Contacts(props)

ContactsPage.layout = PageLayout
ContactsPage.breadcrumb = { title: 'Контакты' }
ContactsPage.headProps = {
	title: pagesTitles[PagesPath.contacts].title,
	description: `Адрес главного офиса Credit Club: г. Екатеринбург, БЦ «Высоцкий» ул. Малышева, д. 51 оф. 25-07. Телефон ☎ +7 (343) 380-00-03. Бесплатные звонки по России ☎ ${MAIN_PHONE_NUMBER}.`,
	ogTitle: 'Контакты — Credit.Club',
	ogDescription:
		'Свидетельства и уставные документы ООО «Кредит.Клаб», МКК «Магазин Кредитов», юридическая информация.',
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
	const cookies = parse(context.req.headers?.cookie || '')
	const appliedCity = getAppliedCityFromCookies(cookies)
	let city = appliedCity

	if (appliedCity) {
		city = appliedCity || getDetectedCityFromCookies(cookies) || DEFAULT_CITY
	}

	return {
		props: { city },
	}
}

export default ContactsPage
